import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { Bundle, BundleListItem, BundleQuery, BundleRequest } from '../models/bundle.model';
import { CatalogFilterOptions, PagedResult } from '../models/product.model';

@Injectable({ providedIn: 'root' })
export class BundleService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${API_BASE_URL}/bundles`;

  getPaged(query: BundleQuery = {}): Observable<PagedResult<BundleListItem>> {
    if (query.filters?.length) {
      return this.search(query);
    }

    let params = new HttpParams();
    if (query.categoryId) params = params.set('categoryId', query.categoryId);
    if (query.brandId) params = params.set('brandId', query.brandId);
    if (query.minPrice != null) params = params.set('minPrice', query.minPrice);
    if (query.maxPrice != null) params = params.set('maxPrice', query.maxPrice);
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    if (query.page) params = params.set('page', query.page);
    if (query.pageSize) params = params.set('pageSize', query.pageSize);
    if (query.sort) params = params.set('sort', query.sort);
    if (query.isActive != null) params = params.set('isActive', query.isActive);
    return this.http.get<PagedResult<BundleListItem>>(this.baseUrl, { params });
  }

  getFilterOptions(): Observable<CatalogFilterOptions> {
    return this.http.get<CatalogFilterOptions>(`${this.baseUrl}/filter-options`);
  }

  search(query: BundleQuery): Observable<PagedResult<BundleListItem>> {
    return this.http.post<PagedResult<BundleListItem>>(`${this.baseUrl}/search`, query);
  }

  getBySlug(slug: string): Observable<Bundle> {
    return this.http.get<Bundle>(`${this.baseUrl}/by-slug/${encodeURIComponent(slug)}`);
  }

  getById(id: string): Observable<Bundle> {
    return this.http.get<Bundle>(`${this.baseUrl}/${id}`);
  }

  create(request: BundleRequest): Observable<Bundle> {
    return this.http.post<Bundle>(this.baseUrl, request);
  }

  update(id: string, request: BundleRequest): Observable<Bundle> {
    return this.http.put<Bundle>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
